import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react-lite";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { AuditLogViewModel } from "../../features/audit-log/audit-log-viewmodel";
import { AppRoutes } from "../../routes/routes";
import { useViewModel } from "../../viewmodel/use-view-model";
import { Breadcrumb } from "../breadcrumb";
import { EmptyView } from "../empty/EmptyView";
import { renderAuditLogType } from "./audit-log-view";
export const AuditLogDetailView = observer(() => {
    const vm = useViewModel(AuditLogViewModel);
    const { t } = useTranslation();
    if (vm.selectedAuditEntry === null) {
        return (_jsx(EmptyView, { message: _jsx(Trans, { i18nKey: "auditLog.detail.notFound", children: _jsx(Link, { to: AppRoutes.AuditLog }) }) }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(Breadcrumb, {}), _jsxs("div", { className: "card mb-3", children: [_jsxs("div", { className: "card-header pt-3 pb-3 d-flex justify-content-between align-items-center", children: [_jsxs("div", { children: [_jsx("span", { className: "fw-semibold", children: t("auditLog.detail.header") }), _jsx("span", { className: "font-monospace", children: vm.selectedAuditEntry.id })] }), _jsx("div", { children: renderAuditLogType(vm.selectedAuditEntry.type) })] }), _jsxs("div", { className: "card-body", children: [_jsx("div", { className: "fs-5", children: vm.selectedAuditEntry.message }), _jsx("div", { className: "fw-bold pt-4 pb-2", children: t("auditLog.detail.parameters") }), _jsx("pre", { children: formatJSON(vm.selectedAuditEntry.params) })] })] })] }));
});
/**
 * Function traverses JSON object, detects serialized JSON, and parses it recursively in place.
 * */
function parseJSONRecursively(json) {
    const result = {};
    for (const key in json) {
        const value = json[key];
        if (typeof value === "string" && value.startsWith("{")) {
            try {
                const parsedChild = JSON.parse(value);
                if (parsedChild) {
                    parseJSONRecursively(parsedChild);
                }
                result[key] = parsedChild;
            }
            catch {
                // not json, only key
            }
        }
        else {
            result[key] = value;
        }
    }
    return result;
}
/**
 * The function constructs and formats JSON objects in multiple steps:
 * - calls parseJSONRecursively to create the full hierarchy of the object (including serialized values)
 * - removes quotation marks, trailing commas, opening and closing curly braces, empty lines
 * - removes first level of indentation
 * */
function formatJSON(json) {
    const parsed = parseJSONRecursively(json);
    // Convert the object to a JSON string with indentation
    const jsonString = JSON.stringify(parsed, null, 2);
    return jsonString
        .replace(/"/g, '') // Remove quotation marks
        .replace(/,\s*$/gm, '') // Remove only trailing commas
        .replace(/{/g, '') // Remove opening curly brace
        .replace(/}/g, '') // Remove closing curly brace.
        .replace(/^\s*[\r\n]/gm, '') // Remove empty lines
        .replace(/^ {2}/gm, ''); // Remove the first level of indentation (2 spaces)
}
